import { useMemo } from 'react';
import { DatePickerWithArrows, Filter } from 'components/molecules';
import { commonTexts } from 'consts/text';
import { FULL_MONTH_FORMAT } from 'consts/dateFormats';
import { GroupDTO, GroupId, SortDirection } from 'types';
import { groupDTOFields } from 'consts/group/groupDTOFields';
import { Dayjs } from 'dayjs';
import { DatePickerContainer } from './ChildrenSettlementPageFilters.styled';
import { sorterOptions } from '../../ChildrenSettlementPage.consts';
import { SortVariant, ChosenFilter } from '../../ChildrenSettlementPage.types';

type Props = {
    sortData: {
        order: SortDirection;
        field: string | undefined;
    };
    updateChosenFilter: (filter: ChosenFilter) => void;
    handleSorterChange: (sorter: SortVariant) => void;
    selectedGroupIds?: GroupId[] | null;
    groups?: GroupDTO[];
    selectedDate: Dayjs;
    isGroupsLoading?: boolean;
};

export const ChildrenSettlementPageFilters = ({
    sortData,
    handleSorterChange,
    selectedGroupIds,
    groups,
    selectedDate,
    isGroupsLoading,
    updateChosenFilter,
}: Props) => {
    const groupOptions = useMemo<{ label: string; value: GroupId }[] | undefined>(() => {
        if (!groups) {
            return [];
        }
        return groups.map((group) => ({
            label: group[groupDTOFields.name],
            value: group[groupDTOFields.id],
        }));
    }, [groups]);

    return (
        <>
            <DatePickerContainer>
                <DatePickerWithArrows
                    label={commonTexts.actionLabels.selectMonth}
                    value={selectedDate}
                    picker="month"
                    format={FULL_MONTH_FORMAT}
                    onChange={(newDate) =>
                        updateChosenFilter({
                            type: 'date',
                            value: newDate,
                        })
                    }
                    onArrowButtonClick={(arrowButtonType) =>
                        updateChosenFilter({
                            type: 'dateNextPrev',
                            value: {
                                direction: arrowButtonType,
                                unit: 'month',
                            },
                        })
                    }
                />
            </DatePickerContainer>
            <Filter
                input={
                    <Filter.Select
                        mode="multiple"
                        value={selectedGroupIds}
                        options={groupOptions}
                        loading={isGroupsLoading}
                        placeholder={commonTexts.actionLabels.select}
                        onChange={(value) =>
                            updateChosenFilter({
                                type: 'groupIds',
                                value,
                            })
                        }
                    />
                }
                label={commonTexts.dataLabels.group}
                width="15%"
            />
            <Filter
                input={
                    <Filter.Select
                        value={sortData.field ? `${sortData.field}_${sortData.order}` : null}
                        options={sorterOptions}
                        placeholder={commonTexts.actionLabels.select}
                        onChange={(value: SortVariant) => handleSorterChange(value)}
                    />
                }
                label={commonTexts.dataLabels.sort}
                width="15%"
            />
        </>
    );
};
